// extracted by mini-css-extract-plugin
export var noSpinners = "_n9-6";
export var percentageInput = "_n9-7";
export var variantColor1 = "_n9-0";
export var variantColor2 = "_n9-1";
export var variantColor3 = "_n9-2";
export var variantColor4 = "_n9-3";
export var variantColor5 = "_n9-4";
export var variantColor6 = "_n9-5";